module.exports = __webpack_public_path__ + "static/media/6.c41a50a8.svg";